import React, { memo } from 'react';

import { Content, Section, Table, Title } from '@src/components/ui/Table';
import { useDictionariesFieldsMap } from '@src/reducers/dictionaries';
import { useCard } from '@src/reducers/product';
import {
  benefitsText,
  commentZaimyText,
  paymentTypesText,
  penaltyText,
  postponementText,
  prolongationCountText,
  prolongationText,
  securityGuarantorDescriptionText,
  securityGuarantorText,
} from '@src/utils/texts';

import styles from './styles.module.scss';

interface IProps {
  className?: string;
}

function renderTableRow(text?: [string, string]) {
  if (!text) {
    return null;
  }
  const [name, value] = text;

  return (
    <Section key={name}>
      <Title size={6}>{name}</Title>
      <Content className={styles.content} size={6} dangerouslySetInnerHTML={{ __html: value }} />
    </Section>
  );
}

export const Conditions: React.FunctionComponent<IProps> = memo((props: IProps) => {
  const { className } = props;
  const dicts = useDictionariesFieldsMap();
  const card = useCard();

  return (
    <Table className={className}>
      <tbody>
        {renderTableRow(prolongationText(card.prolongation))}
        {renderTableRow(prolongationCountText(card.prolongation))}
        {renderTableRow(postponementText(card.postponement))}
        {renderTableRow(penaltyText(card.penalty))}
        {renderTableRow(benefitsText(card.benefits))}
        {renderTableRow(paymentTypesText(card.paymentTypes))}
        {renderTableRow(securityGuarantorText(dicts.security, card.security?.list))}
        {renderTableRow(securityGuarantorDescriptionText(card.security?.description))}
        {renderTableRow(commentZaimyText(card.customerRequirements?.description))}
      </tbody>
    </Table>
  );
});
